import { useSystemConfig } from '@views/hooks'
import React from 'react'
import { MobileNavigator } from './mobileNavigation'
import { WebNavigator } from './webNavigation'

export default function MainNavigation() {
  const { isSmallDevice } = useSystemConfig()
  return isSmallDevice ? <MobileNavigator /> : <WebNavigator />
}
